module.exports = __webpack_public_path__ + "img/about-ch2-problems-climatechange.a8012334.png";